export default __webpack_public_path__ + "static/media/teams.210bf4a5.svg";